<template>
  <div class="float-qrcode-bar" :class="{ 'locale-en': isEnglishLocale }">
    <div class="float-qrcode-item" @mouseenter="activeItem = 'official'" @mouseleave="activeItem = ''">
      <div class="float-icon">
        <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
          <path d="M416 128c-153.6 0-288 115.2-288 268.8 0 89.6 51.2 166.4 128 217.6l-32 96 108.8-57.6c25.6 6.4 51.2 12.8 83.2 12.8 10.7 0 21.3-0.6 32-1.7-6.7-22.9-10.7-46.8-10.7-71.5 0-140.8 128-256 288-256 10.7 0 21.3 0.6 32 1.7C726.7 213.3 583.4 128 416 128z m-83.2 192c-25.6 0-44.8-19.2-44.8-44.8s19.2-44.8 44.8-44.8 44.8 19.2 44.8 44.8-19.2 44.8-44.8 44.8z m166.4 0c-25.6 0-44.8-19.2-44.8-44.8s19.2-44.8 44.8-44.8 44.8 19.2 44.8 44.8-19.2 44.8-44.8 44.8z"/>
          <path d="M725.3 396.8c-140.8 0-256 102.4-256 230.4s115.2 230.4 256 230.4c25.6 0 51.2-6.4 76.8-12.8l83.2 51.2-25.6-76.8c64-44.8 108.8-115.2 108.8-192-6.4-128-121.6-230.4-243.2-230.4z m-64 192c-19.2 0-32-12.8-32-32s12.8-32 32-32 32 12.8 32 32-12.8 32-32 32z m128 0c-19.2 0-32-12.8-32-32s12.8-32 32-32 32 12.8 32 32-12.8 32-32 32z"/>
        </svg>
      </div>
      <span class="float-label">{{ $t('公众号') }}</span>
      <transition name="qrcode-pop">
        <div class="float-qrcode-popup" v-show="activeItem === 'official'">
          <div class="popup-arrow"></div>
          <img :src="$getAssetUrl('/pcImgs/qrcode_official.jpg')" :alt="$t('公众号二维码')" />
          <p>{{ $t('微信扫码关注公众号') }}</p>
        </div>
      </transition>
    </div>

    <div class="float-qrcode-item" @mouseenter="activeItem = 'mini'" @mouseleave="activeItem = ''">
      <div class="float-icon">
        <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
          <path d="M372.825 562.682a56.32 56.32 0 1 1-112.64 0 56.32 56.32 0 0 1 112.64 0z m225.28-56.32a56.32 56.32 0 1 0 0 112.64 56.32 56.32 0 0 0 0-112.64z"/>
          <path d="M512 64C264.576 64 64 264.576 64 512s200.576 448 448 448 448-200.576 448-448S759.424 64 512 64z m206.336 604.16c-2.048 3.584-51.2 85.504-161.28 118.272a20.48 20.48 0 0 1-25.088-12.8 20.48 20.48 0 0 1 12.288-25.6c0.512 0 0.512-0.512 1.024-0.512 89.088-26.624 131.072-93.696 131.584-94.72a20.48 20.48 0 0 1 28.16-7.168 19.968 19.968 0 0 1 13.312 22.528z m27.648-135.168c0 126.464-113.152 228.864-252.928 228.864a274.432 274.432 0 0 1-85.504-13.824l-99.328 52.736 30.72-88.064c-70.144-46.592-119.296-117.76-119.296-179.712 0-126.464 113.152-228.864 252.928-228.864h20.48c123.904 5.632 222.72 107.008 222.72 228.864h0.208z"/>
        </svg>
      </div>
      <span class="float-label">{{ $t('小程序') }}</span>
      <transition name="qrcode-pop">
        <div class="float-qrcode-popup" v-show="activeItem === 'mini'">
          <div class="popup-arrow"></div>
          <img :src="$getAssetUrl('/pcImgs/qrcode_miniprogram.png')" :alt="$t('小程序二维码')" />
          <p>{{ $t('微信扫码进入小程序') }}</p>
        </div>
      </transition>
    </div>

    <div class="float-qrcode-item" @click="scrollToTop">
      <div class="float-icon">
        <svg viewBox="0 0 1024 1024" width="24" height="24" fill="currentColor">
          <path d="M494.784 295.808a24.576 24.576 0 0 1 34.432 0l236.544 232.32a24.064 24.064 0 0 1 0 34.304 24.576 24.576 0 0 1-34.432 0L512 345.856 292.672 562.432a24.576 24.576 0 0 1-34.432 0 24.064 24.064 0 0 1 0-34.304l236.544-232.32z"/>
          <path d="M512 288a24.32 24.32 0 0 1 24.32 24.32v399.36a24.32 24.32 0 1 1-48.64 0V312.32A24.32 24.32 0 0 1 512 288z"/>
        </svg>
      </div>
      <span class="float-label">{{ $t('顶部') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatQrcode',
  data() {
    return {
      activeItem: ''
    }
  },
  computed: {
    isEnglishLocale() {
      return this.$i18n && this.$i18n.locale === 'en'
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ behavior: 'smooth', top: 0 });
    }
  }
}
</script>

<style scoped lang="scss">
.float-qrcode-bar {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.float-qrcode-item {
  position: relative;
  width: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  background: #00903B;
  color: #fff;
  cursor: pointer;
  transition: background 0.25s;

  &:first-child {
    border-radius: 0;
  }
  &:last-child {
    border-radius: 0 0 6px 6px;
  }
  &:hover {
    background: #007a32;
  }
}

.float-qrcode-bar.locale-en .float-qrcode-item {
  width: 88px;
  padding: 12px 6px;
}

.float-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.float-label {
  font-size: 11px;
  margin-top: 4px;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.float-qrcode-bar.locale-en .float-label {
  white-space: normal;
  text-align: center;
  line-height: 1.2;
  letter-spacing: 0;
  font-size: 10px;
}

.float-qrcode-popup {
  position: absolute;
  right: calc(100% + 10px);
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 16px;
  text-align: center;
  width: 170px;

  .popup-arrow {
    position: absolute;
    right: -6px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    width: 12px;
    height: 12px;
    background: #fff;
    box-shadow: 2px -2px 4px rgba(0, 0, 0, 0.05);
  }

  img {
    width: 140px;
    height: 140px;
    border-radius: 4px;
    display: block;
    margin: 0 auto;
  }

  p {
    margin: 10px 0 0;
    font-size: 13px;
    color: #666;
    line-height: 1.4;
  }
}

.float-qrcode-bar.locale-en .float-qrcode-popup {
  width: 220px;
}

.float-qrcode-bar.locale-en .float-qrcode-popup p {
  line-height: 1.5;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
}

// 弹出动画
.qrcode-pop-enter-active,
.qrcode-pop-leave-active {
  transition: all 0.25s ease;
}
.qrcode-pop-enter,
.qrcode-pop-leave-to {
  opacity: 0;
  transform: translateY(-50%) translateX(10px);
}

</style>
